import styled from 'styled-components';

export default {
  Gripper: styled.div<{ isDisabled: boolean }>`
    position: absolute;
    top: 0;
    left: 0;

    width: calc(100% - 56px);
    height: 70px;

    z-index: 22;

    pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};

    @media (min-width: 768px) {
      display: none;
    }

    &::before {
      content: '';

      position: absolute;
      top: 15px;
      left: 55%;

      width: 8%;
      height: 5px;

      transform: translate(-50%, -50%);

      border-radius: 5px;

      background-color: rgba(0, 0, 0, 0.2);

      z-index: 22;
    }
  `,
};
